import React from 'react'
import Header from './Header/Header'
import Content from './Content/Content'
import {BrowserRouter} from "react-router-dom";


import './App.scss'



function App() {

    return (
        <BrowserRouter>
        <React.Fragment>
                <Header/>
                <Content />
        </React.Fragment>
        </BrowserRouter>
    );
}

export default App;
